import { useLocalSearchParams } from 'expo-router';
import SeasonEditorScreen from '@/screens/SeasonEditorScreen';
import { LeagueManagerRouteGate } from '@/components/route/RouteGate';
import { normalizeStringParam } from '@/lib/routes';

export default function SeasonEditorRoute() {
  const params = useLocalSearchParams<{ id?: string | string[] }>();
  const leagueId = normalizeStringParam(params.id) ?? '';

  return (
    <LeagueManagerRouteGate leagueId={leagueId}>
      <SeasonEditorScreen />
    </LeagueManagerRouteGate>
  );
}
